import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';

// Contact Support modal for Virtual Hardhat
// TODO: Integrate with backend/email service

function ContactSupportModal({ open = false, onClose }) {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = useCallback((e) => {
    setForm((prevForm) => ({ ...prevForm, [e.target.name]: e.target.value }));
  }, []);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    // TODO: Send to backend/email
    setSubmitted(true);
  }, []);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full relative animate-fade-in">
        <button
          className="absolute top-4 right-4 text-gray-400 hover:text-yellow-500 text-2xl font-bold focus:outline-none"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        <h2 className="text-2xl font-bold mb-4 text-yellow-500">Contact Support</h2>
        {submitted ? (
          <div className="text-green-600 font-semibold">
            Thank you! We&apos;ll get back to you soon.
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Your Name"
              className="px-4 py-2 rounded border border-yellow-300"
              required
            />
            <input
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Your Email"
              className="px-4 py-2 rounded border border-yellow-300"
              required
              type="email"
            />
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              placeholder="How can we help?"
              className="px-4 py-2 rounded border border-yellow-300"
              required
              rows={4}
            />
            <button
              type="submit"
              className="bg-yellow-400 text-black px-6 py-2 rounded font-bold shadow hover:bg-yellow-500 transition-transform hover:scale-105"
            >
              Send
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

ContactSupportModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default ContactSupportModal;
